const advantages = [
  {
    icon: "ri-flashlight-line",
    title: "免下载免安装",
    desc: "打开网页就能玩，省去下载和安装的等待，随时开局，随时暂停。",
  },
  {
    icon: "ri-apps-2-line",
    title: "海量游戏库",
    desc: "覆盖竞技对战、角色扮演、休闲益智、策略塔防等多种类型，总有一款适合你。",
  },
  {
    icon: "ri-filter-3-line",
    title: "智能筛选搜索",
    desc: "支持题材、标签多条件联合筛选与关键词搜索，几秒钟就能定位想要的游戏。",
  },
  {
    icon: "ri-device-line",
    title: "多端随时畅玩",
    desc: "电脑与手机均可打开，界面适配触控操作，通勤路上也能轻松试玩。",
  },
];

export default function HomeAdvantages() {
  return (
    <section aria-label="平台介绍与优势">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-700">
              <i className="ri-information-line"></i>
              关于平台
            </span>
            <h2 className="mt-4 text-2xl font-black text-foreground-900 md:text-3xl">
              网页游戏直接玩，让每一款游戏都触手可及
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们专注收集与整理各类网页游戏，把游戏封面、类型标签、玩法介绍与试玩入口集中在一起。
              无需注册、无需下载，打开页面即可浏览与试玩，帮助玩家用最短的时间找到心动的那一款。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              平台仍在持续成长，游戏库与筛选功能会不断丰富。如果你有想玩的游戏类型，也欢迎通过反馈入口告诉我们。
            </p>
          </div>
          <div className="grid grid-cols-1 gap-px bg-background-200 sm:grid-cols-2">
            {advantages.map((item) => (
              <div key={item.title} className="bg-background-50 p-6 md:p-7">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${item.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-900">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}